export default {
    'journey.contacts[0]' : {
        'read': true,
        'write': true,
        'mutate': true,
        'model': 'Contact',
        'profileSync': {
            'toProfile' : {
                'enable': true,
                'overwrite': true,
                'properties': [ 'firstName', 'lastName', 'phone', 'email', 'dob' ],
            },
            'fromProfile' : {
                'enable': true,
                'overwrite': false,
            },
            'profilePath': '$',
        },
    },
};
